export interface StaticPageModel {
  name: string;
  slug: string;
  positionType: StaticPagePositionType;
}

export interface AppPageModel {
  id: string;
  creationTime: string;
  creatorId: string;
  lastModificationTime: string;
  lastModifierId: string;
  name: string;
  content: string;
  slug: string;
  positionType: StaticPagePositionType;
}

export type StaticPagePositionType = 'Header' | 'Footer' | 'DirectURL';
export enum StaticPagePositionEnum {
  'Header' = 'Header',
  'Footer' = 'Footer',
  'DirectURL' = 'DirectURL',
}
